import { action } from 'easy-peasy';

import { IActionSetActTeam } from '../types';

const setActTeam: IActionSetActTeam = action((state, payload) => {
  state.current = payload;
});

export default setActTeam;
